var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavigationPanelRightReveal = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 10,
  viewBox: "0 0 17 10",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.856 5.078H1M5.078 1 1 5.078l4.078 4.078m10.504 0V1",
  stroke: "#348CFD",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgNavigationPanelRightReveal as ReactComponent };
export default __webpack_public_path__ + "assets/images/navigation-panel-right-reveal.svg";